export default function BurnabyOverview() {
  const keyPoints = [
    {
      icon: 'ri-home-4-line',
      title: 'Principal Residence Requirement',
      description:
        'STRs are only permitted in your principal residence, similar to Vancouver regulations.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Business License Required',
      description:
        'All STR operators must obtain a valid Burnaby business license before listing.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Zoning Restrictions',
      description:
        'STRs are permitted in residential zones with specific conditions and limitations.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety Compliance',
      description:
        'Properties must meet fire safety, building code, and insurance requirements.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Regulatory Overview
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Understanding Burnaby&apos;s STR Framework
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Burnaby has implemented comprehensive short‑term rental regulations to balance housing
            availability with tourism accommodation needs. Here&apos;s what property owners need to
            know.
          </p>
        </div>

        {/* Key points grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {keyPoints.map((point) => (
            <div
              key={point.title}
              className="bg-[#F8F8F8] rounded-2xl p-8 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${point.icon} text-2xl text-[#882629]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">{point.title}</h3>
              <p className="text-[#505A5A]/70 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        {/* Summary stats */}
        <div className="mt-16 bg-gradient-to-r from-[#882629]/5 to-[#882629]/10 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$150</div>
              <p className="text-[#505A5A]/70">Annual License Fee</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">90 Days</div>
              <p className="text-[#505A5A]/70">Max Rental Days (Non‑Principal)</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$1,000+</div>
              <p className="text-[#505A5A]/70">Daily Violation Penalties</p>
            </div>
          </div>
        </div>

        {/* Enforcement Style */}
        <div className="mt-12 bg-gradient-to-r from-[#882629] to-[#6E1F22] rounded-2xl p-8 lg:p-10 text-white shadow-xl">
          <div className="flex flex-col lg:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <i className="ri-shield-check-line text-6xl"></i>
            </div>
            <div className="flex-grow text-center lg:text-left">
              <h4 className="text-2xl font-bold mb-3">
                Enforcement Style: Provincial Registry + Complaint-Based
              </h4>
              <p className="text-lg text-white/90 leading-relaxed">
                Burnaby follows BC's Provincial Registry requirements with automatic platform de-listing for non-compliant properties. The city also investigates neighbor complaints and conducts regular audits. Daily penalties of $1,000+ apply for operating without proper licensing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
